import React from 'react';
import PropTypes from 'prop-types';

const CurrentUser = (props) => {
  if (!props.user) {
    return null;
  }
  return (
    <div className="currentUser">
      <p>{props.user.name}</p>
      <i className="bi_user-male" />
      <button className="currentUser_logout" onClick={props.onLogout} title="ESCI">
        <i className="bi_interface-power" />
      </button>
    </div>
  );
};

CurrentUser.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
    id: PropTypes.string,
    accessToken: PropTypes.string,
    lastName: PropTypes.string,
    name: PropTypes.string,
  }),
  onLogout: PropTypes.func,
};

export default CurrentUser;



// WEBPACK FOOTER //
// ./src/components/current-user.js